import React from 'react'
const ContdownTimerRender = ({days, hours, minutes, seconds, completed }) => {
    // if (completed) {
    //     // after time over
    //     return  <div className="centered ">
    //     <div className="MENbtn d-flex ">
    //         <h4 className="text-warning">THE TIME IS OVER</h4>
    //     </div>
    //     </div>;
    //   } else {
        // Render a countdown
        return         <div className="PositionEnLive d-flex">
        <div className="card ENtextXLive p-1">
          <h6 className="fw-bold text-black">{days > 0 ? days : "00"}</h6>
          <small className="fw-bold EnDayX">Days</small>
        </div>
  
        <div className="card ENtextXLive text-black py-1 px-3 amx-1">
          <h6 className="fw-bold ">{hours > 0 ? hours : "00"}</h6>
          <small className="fw-bold EnDayX">Hrs</small>
        </div>
  
        <div className="card ENtextXLive text-black py-1 px-3 amx-1">
          <h6 className="fw-bold ">{minutes > 0 ? minutes : "00"}</h6>
          <small className="fw-bold EnDayX">Min</small>
        </div>
  
        <div className="card ENtextXLive text-black py-1 px-3 amx-1">
          <h6 className="fw-bold ">{seconds > 0 ? seconds : "00"}</h6>
          <small className="fw-bold EnDayX">Sec</small>
        </div>
      </div>
    
      // }
}

export default ContdownTimerRender